import React from 'react'
import PropTypes from 'prop-types'
import Link from '../link'
import {Button, Flex, Text} from '@chakra-ui/react'
import {ArrowRight2Icon} from '../icons'
import DynamicImage from '../dynamic-image'

const ICON_WIDTHS = {base: 90, md: 104}

const size = {
    base: '10.25rem',
    md: '14rem'
}

const DashboardIconTile = ({colorScheme = 'stokkePink', label, icon: Icon, image, ...props}) => {
    const Component = props.href || props.to ? Link : Button

    return (
        <Component variant="unstyled" {...props}>
            <Flex
                flexDirection="column"
                alignItems="stretch"
                gap={2.5}
                minWidth={size}
                width={size}
                maxWidth={size}
                flexBasis={size}
                flexShrink={0}
                flexGrow={0}
            >
                <Flex
                    alignItems="center"
                    justifyContent="center"
                    color={`${colorScheme}.dark`}
                    backgroundColor={`${colorScheme}.mid`}
                    boxSize={size}
                >
                    {Icon ? (
                        <Icon boxSize={{base: '5.625rem', md: '6.5rem'}} />
                    ) : (
                        image && (
                            <DynamicImage
                                src={`${image}[?sw={width}&q=60]`}
                                // update also ICON_WIDTHS when changing this
                                boxSize={{base: '5.625rem', md: '6.5rem'}}
                                widths={ICON_WIDTHS}
                                imageProps={{
                                    'aria-hidden': true,
                                    objectFit: 'contain',
                                    alt: label ? label : '',
                                    cursor: 'pointer'
                                }}
                            />
                        )
                    )}
                </Flex>

                {label && (
                    <Flex
                        justifyContent="space-between"
                        alignItems="flex-start"
                        gap={2}
                        maxWidth={size}
                    >
                        <Text
                            minWidth={0}
                            textAlign="start"
                            textStyle="Regular XLarge"
                            whiteSpace="normal"
                        >
                            {label}
                        </Text>
                        <ArrowRight2Icon boxSize={4} />
                    </Flex>
                )}
            </Flex>
        </Component>
    )
}

DashboardIconTile.propTypes = {
    colorScheme: PropTypes.string,
    label: PropTypes.string,
    icon: PropTypes.elementType,
    image: PropTypes.string,
    href: PropTypes.string,
    to: PropTypes.string
}

export default DashboardIconTile
